import React from 'react';
// import imageFile from '../../../../assets/images/fondo.png';
import imageFile from '../../../../assets/images/Pattern-yax.png';

import styles from './AuthDesktop.module.scss';

export class AuthDesktop extends React.Component {
    
    render() {
        const {
            content
        } = this.props;
        return (
            <div className={styles["auth-desktop-container"]}>
                <div className={styles["img-container"]}>
                    <img className={styles["image"]} src={imageFile} alt="fondo"/>
                </div>
                <div className={styles["content-container"]}>
                    {content}
                </div>
            </div>
        )
    }

}


AuthDesktop.propTypes = {
    
};

export default AuthDesktop;